import { IErrorCollection } from "./http-service";
import { ToastService } from "./toast-service";

export class ValidationHelper {
    public static RaiseToastsForValidationErrors(httpResponseData: any) {
        if (httpResponseData != null && httpResponseData.errorCollection != null) {
            var options: ToastrOptions = {
                closeButton: true,
                timeOut: 0
            };

            (httpResponseData.errorCollection as []).map(function (item: any, index) {
                ToastService.sendToast({ Message: item.errorMessage, Status: "Error", Options: options, RemoveExistingToasts: index == 0 });
            });
        }
    }

    // ----------------------------------------------------------
    // Clears any errors off the form
    // ----------------------------------------------------------
    public static RemoveFormErrors(formId: string) {
        if (formId == null) {
            return;
        }

        if (!formId.startsWith('#') && !formId.startsWith('.')) {
            formId = '#' + formId;
        }

        $(formId + ' .has-error').removeClass('has-error');
        $(formId + ' .has-error-inline').removeClass('has-error-inline');
        $(formId + ' .error-state').removeClass('error-state');
        $(formId + ' .help-block').remove();
    }

    public static ParseValidation(data: IErrorCollection[], formId: string) {
        var formSelector = formId;
        if (!formId.startsWith('#') && !formId.startsWith('.')) {
            formSelector = '#' + formId;
        }

        ValidationHelper.RemoveFormErrors(formSelector);

        var message = '';
        if (data.length > 0) {
            $.each(data, function (i, item) {
                message = message + '<p>' + data[i].errorMessage + '</p>';
                
                if (data[i].objectId && data[i].objectId != '') {
                    if (data[i].objectId.indexOf('.') > -1) {
                        // If we've got a [.] in the Id (object Id generated by ASP.NET Core Validation) then escape it for jQuery selector (jQuery sees this as a class selector)
                        data[i].objectId = data[i].objectId.replace('.', '\\.');
                    }

                    var ctrl = $(formSelector + ' #' + data[i].objectId);
                    if (ctrl.length == 0) {
                        // try with name
                        ctrl = $(formSelector + ' [name="' + data[i].objectId + '"]');
                    }
                    
                    if (ctrl.length > 0) {
                        ctrl.addClass('has-error');
                        ctrl.addClass('error-state');

                        var label = ctrl.closest('div.form-group, label');

                        if (label.length == 0) {
                            // If no label was found using standard search, search within the root div for a label 'for' the specified control
                            label = $(formSelector + " label[for='" + data[i].objectId + "']");
                        }

                        var errorBlock = '<small class="help-block" style="display: block;" data-by-validator-for="' + data[i].objectId + '">' + data[i].errorMessage + '</small>';

                        if (label.length > 0) {
                            label.addClass('has-error');
                        }

                        var helpBlockLocation = ctrl.next('.help-block-location');

                        if (helpBlockLocation.length == 0) {
                            // If no help block location was found using standard search, search within the root div for a label 'for' the specified control
                            helpBlockLocation = $(formSelector + " .help-block-location[for='" + data[i].objectId + "']");
                        }

                        if (helpBlockLocation.length > 0) {
                            helpBlockLocation.append(errorBlock);
                        }
                        else if (label.length > 0) {
                            // no explicit help block location, add the error message after the label, if we have one
                            label.append(errorBlock);
                        }
                    }
                    else {
                        // Display toasts for any unbound errors
                        toastr.error(data[i].errorMessage);
                    }
                }
                else {
                    // Display toasts for any unbound errors
                    toastr.error(data[i].errorMessage);
                }
            });
        }
        else {
            message = 'An Error Occurred Saving Changes';
        }
    }
}